import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { CatalogServiceResponse } from './models/response-catalog-model';
import { BaseFilterTypeRequest, EntityFederalCircuitRequest, MatterTypeOrganismRequest, OrganismTypeCircuitRequest, OrganismTypeOrganCircuitRequest, ProcedureTypeRequest, SubjectOrganismTypeRequest } from './models/request-catalog-model';

@Injectable({
  providedIn: 'root',
})
export class CatalogoService {

  private urlBaseService = environment.FilterCourtURL;
  private http: HttpClient = inject(HttpClient);


  /**
   * Maneja los errores de la solicitud HTTP, se recibe el nombre de la operación que se estaba realizando, se registra el error en la consola y se retorna un Observable con un mensaje de error personalizado
   * @param operation 
   * @returns 
   */
  private handleError(operation: string) {
    return (error: any) => {
      console.error(`Error en ${operation}:`, error);
      return throwError(() => new Error(`No se pudo completar la operación: ${operation}`));
    };
  }

  /**
   * Realiza una solicitud POST a un endpoint del catálogo, se recibe el endpoint y los datos a enviar, se hace la solicitud HTTP y se retorna la respuesta como un Observable con la información del servicio
   * @param endpoint 
   * @param data 
   * @returns 
   */
  private postCatalog<TRequest>(endpoint: string, data: TRequest): Observable<CatalogServiceResponse> {
    return this.http.post<CatalogServiceResponse>(`${this.urlBaseService}${endpoint}`, data)
      .pipe(catchError(this.handleError(endpoint)));
  }

  /**
   * Obtiene los tipos de filtros disponibles
   * @param data 
   * @returns 
   */
  getTypesFilters(data: BaseFilterTypeRequest) {
    return this.postCatalog('ObtenerTipoFiltro', data);
  }

  /**
   * Obtiene las entidades federales por circuito
   * @param data 
   * @returns 
   */
  getEntitiesFederalCircuit(data: EntityFederalCircuitRequest) {
    return this.postCatalog('ObtenerEntidadFederativaXCircuito', data);
  }

  /**
   * Obtiene los tipos de organismos por circuito
   * @param data 
   * @returns 
   */
  getTypesOrganismCircuit(data: OrganismTypeCircuitRequest) {
    return this.postCatalog('ObtenerCircuitosXTipoOrganismo', data);
  }

  /**
   * Obtiene los temas por tipo de organismo
   * @param data 
   * @returns 
   */
  getSubjectOrganismType(data: SubjectOrganismTypeRequest) {
    return this.postCatalog('ObtenerMateriasXTipodeOrganismo', data);
  }

  /**
   * Obtiene los organismos por tipo de organismo y circuito
   * @param data 
   * @returns 
   */
  getOrganismTypeOrganCircuit(data: OrganismTypeOrganCircuitRequest) {
    return this.postCatalog('ObtenerOrganismoXTipodeOrganismoXCircuito', data);
  }

  /**
   * Obtiene los tipos de asuntos por organismo y materia
   * @param data 
   * @returns 
   */
  getMatterTypeOrganism(data: MatterTypeOrganismRequest) {
    return this.postCatalog('ObtenerTipoAsuntoXOrganismoXMateria', data);
  }

  /**
   * Obtiene los tipos de procedimiento
   * @param data 
   * @returns 
   */
  getProcedureType(data: ProcedureTypeRequest) {
    return this.postCatalog('ObtenerTipoProcedimiento', data);
  }

}
